export default () => ({
  modals: Array<string>(),
  selectedModal: null,
});
